import script from "./homePage2.vue?vue&type=script&setup=true&lang=js"
export * from "./homePage2.vue?vue&type=script&setup=true&lang=js"

import "./homePage2.vue?vue&type=style&index=0&id=06529644&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06529644"]])

export default __exports__